import { prefetchRecentSales } from '../hooks/useRecentSales';

/**
 * Opens an alert's machine in the planogram with the slot drawer on the alert's product.
 * Recent sales are fetched now so they are ready when the drawer mounts.
 * `alert` is a raw /alerts or /alerts-management row.
 */
const openAlertInPlanogram = (alert, navigate, clientId) => {
  prefetchRecentSales(clientId, alert.d_store_id, alert.d_product_id).catch(() => {});
  navigate('/machines', {
    state: {
      defaultTab: 'planograma',
      machineId: alert.d_store_id,
      productId: alert.d_product_id,
      selectionCodes: alert.selection_code || [],
      filters: {
        group: alert.group,
        location: alert.location
      }
    }
  });
};

export default openAlertInPlanogram;
